import styles from "./SimilarContentCard.module.scss"
import LikeButton from "../../../../components/shared/LikeButton";
import {genresData} from "../../../../constants/structure";
import {useTranslation} from "react-i18next";
import {setCurrentItem} from "../../../../store/slices/currentItem.slice";
import {ROUTES} from "../../../../constants/routes";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import React from "react";
import {movieTitleHandler, posterPathHandler} from "../../../../utils/helpers";
import RatingBadge from "../../../../components/shared/RatingBadge";

type Movie = {
  id: number;
  genre_ids: number[];
  reviews_count: number | null;
  adult: boolean;
  backdrop_path: string;
  original_language: string;
  original_title: string;
  overview: string;
  overview_ru: string;
  overview_ua: string;
  popularity: number;
  poster_path: string;
  release_date: string;
  title: string;
  title_ru: string;
  title_ua: string;
  video: boolean;
  vote_average: number;
  vote_count: number;
  not_found: boolean;
  liked: boolean;
  imdb_rating?: number | null;
  imdb_votes?: number | null;
  kinopoisk_rating?: number | null;
  kinopoisk_votes?: number | null;
};

interface ISimilarContentCardProps {
  isMobile: boolean
  movie: Movie
  likeHandler: (e: any, item: any, liked: boolean) => void;
  updateFieldLocal: (id: any, item: any, field: any) => void;
  liked: boolean
}

const SimilarContentCard = ({
  isMobile,
  movie,
  likeHandler,
  liked,
  updateFieldLocal
}: ISimilarContentCardProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const title = movieTitleHandler(i18n.language, movie);
  const img = `${process.env.REACT_APP_IMG_BASE_URL}${posterPathHandler(i18n.language, movie)}`

  return (
    <div
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        dispatch(setCurrentItem(movie));
        navigate(`${ROUTES.DETAILS}/${movie.id}`);
        window.location.reload();
      }}
      className={styles.cardWrapper}
    >
      <div className={styles.imgSimilarWrapper}>
        <img
          width={119}
          height={166}
          className={styles.image}
          src={`${process.env.REACT_APP_IMG_BASE_URL}${img}`}
          alt="#"
        />
      </div>
      <div className={styles.textWrapper}>
        <h4 className={styles.movieTitle}>{title}</h4>
        <div className={styles.infoWrapper}>
          <div className={styles.rowInfoWrapper}>
            <div className={styles.badge}>{movie.release_date?.substring(0, 4) || '2022'}</div>
            <p className={styles.country}>USA</p>
          </div>
          <p className={styles.description}>
            <span>{movie.genre_ids[0] && t(`${genresData.find((genre) => genre.id === movie.genre_ids[0])?.name}`)}{' '}</span>
            <span>{movie.genre_ids[1] && t(`${genresData.find((genre) => genre.id === movie.genre_ids[1])?.name}`)}</span>
          </p>
          <div className={styles.cardActionsWrapper}>
            <RatingBadge
              voteAverage={movie.vote_average}
              imdbRating={movie.imdb_rating}

              kinopoiskRating={movie.kinopoisk_rating}

              variant="card"
            />
            <LikeButton
              count={movie.vote_count}
              direction="row"
              isMobile={isMobile}
              liked={liked}
              clickHandler={likeHandler}
              updateFieldLocal={updateFieldLocal}
              item={movie}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SimilarContentCard
